const initialState = {
    logoUploadedUrl: null,
    applicationName: "Vision",
    sidebarColour: "#0C2235",
    sidebarTextColour: "#FFFFFF",
    sidebarActiveMenuColour: "#008CFF",
    logoUploadedPreview: null,
    sidebarColourPreview: "",
    sidebarTextColourPreview: "",
    sidebarActiveMenuColourPreview: "",
};
 
const ThemeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "RESET_THEME_PREVIEW":
            return {
                ...state,
                sidebarColourPreview: "",
                sidebarTextColourPreview: "",
                sidebarActiveMenuColourPreview: "",
                logoUploadedPreview: null,
            };
        case "SET_SIDEBAR_COLOUR_PREVIEW":
            return {
                ...state,
                sidebarColourPreview: action.payload,
            };
        case "SET_SIDEBAR_TEXT_COLOUR_PREVIEW":
            return {
                ...state,
                sidebarTextColourPreview: action.payload,
            };
        case "SET_SIDEBAR_ACTIVE_MENU_COLOUR_PREVIEW":
            return {
                ...state,
                sidebarActiveMenuColourPreview: action.payload,
            };
        case "SET_LOGO_UPLOADED_PREVIEW":
            return {
                ...state,
                logoUploadedPreview: action.payload,
            };
        case "SET_THEME_LOGO_UPLOADED_URL":
            return {
                ...state,
                logoUploadedUrl: action.payload.logoUploadedUrl,
                applicationName: action.payload.applicationName,
            };
        case "SET_COLOURS":
            return {
                ...state,
                sidebarColour: action.payload.sidebarColour,
                sidebarTextColour: action.payload.sidebarTextColour,
                sidebarActiveMenuColour: action.payload.sidebarActiveMenuColour,
            };
        case "RESET_THEME":
            return {
                ...initialState
            };
        default:
            return state;
    }
};
 
export default ThemeReducer;